import { UpperCasePipe } from "@angular/common";
import { Component, NgZone, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslatePipe } from "@app/common-codes/components/directives/TranslatePipe";
import { UploadDocumentComponent } from "./upload-document.component";
import { ValidationCodeComponent } from "../validation-code/validation-code.component";
import { GenetricDetailComponent } from "@app/common-codes/components/edit-components/generic-detail.component";
import { TruckerActivity } from "@app/common-codes/models/matwins-tenant/TruckerActivity.model";
import { IStaticStylesConfig } from "@app/common-codes/skins/_primitives/IStaticStylesConfig";
import { TranslationService } from "@app/common-codes/services/TranslationService";
import { GenericValidationService } from "@app/common-codes/services/GenericValidationService";
import { EntityConstructor } from "@app/common-codes/services/DependecyInjection.provider";
import { IEntityMetaData } from "@app/common-codes/_models/IEntityMetaData";
import { MatwinsSkins } from "@app/common-codes/skins/global.skin";

@Component({
    selector: 'app-uploads',
    standalone: true,
    imports: [TranslatePipe, UploadDocumentComponent, ValidationCodeComponent],
    templateUrl: './uploads.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: ``
})
export class UploadsComponent extends GenetricDetailComponent<TruckerActivity> {
    override Editable: boolean = true;
    override ComponentEntityClass: EntityConstructor<TruckerActivity> = TruckerActivity;
    override entityMetaData: IEntityMetaData = TruckerActivity.getMetaData();
    override Skin: IStaticStylesConfig = MatwinsSkins.QrCode1;
    override isModal: boolean = true;
    public override get RequiredPermissions(): string[] {
        return [];
    }
    public override get HasRequiredPermissions(): boolean {
        return true;
    }
    sub: any;
    activityId: string | null = null;
    authenticated: boolean = false;
    files: File[] = [];
    sucessUploaded: boolean = false;

    constructor(private activatedroute: ActivatedRoute, translationService: TranslationService,
        route: ActivatedRoute,
        router: Router,
        validationService: GenericValidationService,
        ngZone: NgZone
    ) {
        super(route, router, translationService, validationService, ngZone);
    }

    override parseToEntityInstance(): void {
        if (this.EntityInstance && this.editingEntity()) {
            Object.assign(this.EntityInstance, this.editingEntity());
        }
    }
    override getEmptyEntity(): TruckerActivity {
        return new TruckerActivity();
    }

    override ngOnInit(): void {
        super.ngOnInit();

        this.sub = this.activatedroute.paramMap.subscribe(params => {
            this.activityId = params.get('activityId');
        });
    }

    async onValidationSuccess(authenticatedUser: any) {
        this.authenticated = true;
        try {
            const entity = await this.dataService.get(+this.activityId!);
            this.editingEntity.set(entity);
        }
        catch (error) {
            this.editingEntity.set(null);

        }
    }

    onFilesChanged(files: File[]) {
        this.files = files;
    }

    // async onUploadFile() {
    //     if (this.files && this.files.length > 0) {
    //         const formData = new FormData();
    //         formData.append('file', this.files[0]);
    //         formData.append('entityId', this.activityId ?? '');  // entity sérialisé
    //         formData.append('relationName', this.imageRelationName);
    //         //await new Promise(resolve => setTimeout(resolve, 1000));
    //         await this.dataService.execute<any>('Post', 'upload', formData);
    //         // await fetch('https://localhost:7105/api/truckeractivities/upload', {
    //         //     method: 'POST',
    //         //     body: formData,
    //         //     headers: {
    //         //         'X-Custom-Matwins-ClientId': '019b2245-5cb6-7a91-b1bd-183952276fd5',
    //         //         'X-Custom-Matwins-PosId': '1'
    //         //     }
    //         // });

    //         // await fetch('https://localhost:7105/api/test/testpostok', {
    //         //     method: 'POST',
    //         //     body: formData,
    //         //     headers: {
    //         //         'X-Custom-Matwins-ClientId': '019b2245-5cb6-7a91-b1bd-183952276fd5',
    //         //         'X-Custom-Matwins-PosId': '1'
    //         //     }
    //         // });
    //         this.sucessUploaded = true;

    //         // return true;
    //     }
    // }

    async onUploadFiles() {
        // if (!this.files || this.files.length === 0) {
        //     // return false;
        // }
        if (!this.files || this.files.length === 0) {
            return;
        }
        try {
            const formData = new FormData();
            this.files.forEach(file => {
                formData.append('files', file);
            });
            formData.append('entityId', this.activityId!);
            formData.append('relationName', 'FK_Attachments');
            const result = await this.dataService.execute<any>('Post', 'upload-multiple', formData);
            // this.sucessUploaded = true;
            // const response = await fetch('https://localhost:7105/api/truckeractivities/upload-multiple', {
            //     method: 'POST',
            //     body: formData,
            //     headers: {
            //         'X-Custom-Matwins-ClientId': '019b2245-5cb6-7a91-b1bd-183952276fd5',
            //         'X-Custom-Matwins-PosId': '1'
            //     }
            // });

            // if (response.ok) {
            //     this.sucessUploaded = true;
            // }
            // Test avec une promesse simple - PAS de HTTP
            // await new Promise(resolve => setTimeout(resolve, 1000));

            // console.log('Promesse résolue');
            this.sucessUploaded = true;
            // return true;
        }
        catch (error) {
            console.error('Error uploading files:', error);
            // return false;
        }
    }
}
